import type { ReactNode } from 'react';
import { QueryStatus } from './QueryStatus';

type Props = {
  title: string;
  isLoading?: boolean;
  error?: unknown;
  errorText?: string;
  children: ReactNode;
};

/** Page frame of create / edit / detail pages: header + a single box with load status. */
export const DetailLayout = ({
  title,
  isLoading = false,
  error,
  errorText = 'Ошибка загрузки данных',
  children,
}: Props) => (
  <>
    <section className="content-header">
      <h1>{title}</h1>
    </section>
    <section className="content">
      <div className="box box-primary">
        <div className="box-body">
          <QueryStatus isLoading={isLoading} error={error} errorText={errorText} />
          {children}
        </div>
      </div>
    </section>
  </>
);

/** Extra box below the main one (related tables, sub-forms). */
export const DetailBox = ({ title, children }: { title?: string; children: ReactNode }) => (
  <div className="box box-primary">
    {title && (
      <div className="box-header with-border">
        <h3 className="box-title">{title}</h3>
      </div>
    )}
    <div className="box-body">{children}</div>
  </div>
);
